import type {ComponentType} from 'react'
import {isSocialStudiesPremium} from '@freckle/educator-entities/ts/common/logic/premium-access'
import {Alert} from '@freckle/educator-materials/ts/components/alert'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {SafeTrans} from '@freckle/educator-materials/ts/helpers/translate/component'
import {GetPremiumLink} from '@freckle/classroom/ts/common/components/get-premium-link'
import {PageWrapper} from '@freckle/classroom/ts/common/components/page-wrapper'
import {WithResources} from '@freckle/classroom/ts/common/components/with-resources'
import {usePremiumLicenses} from '@freckle/classroom/ts/hooks/use-premium-licenses'
import {ShareAssignmentErrorModalWrapper} from './share-assignment-error-modal'

type Props = {
  component: ComponentType<object>
}

export function SocialStudiesTakedown({component: Component}: Props) {
  const {t} = useSafeTranslation()

  const premiumLicenses = usePremiumLicenses()
  return (
    <ShareAssignmentErrorModalWrapper shareError>
      <WithResources
        resources={{premiumLicenses}}
        render={({premiumLicenses}) => {
          const isPremium = isSocialStudiesPremium(premiumLicenses)
          if (isPremium) {
            return <Component />
          } else {
            return (
              <PageWrapper pageHeaderText={t('SOCIAL_STUDIES_TAKEDOWN_PAGE_HEADER_TEXT')}>
                <Alert type="premium">
                  <SafeTrans
                    i18nKey="SOCIAL_STUDIES_TAKEDOWN_PREMIUM_ALERT"
                    components={{
                      quoteRequestModalLink: (
                        <GetPremiumLink
                          linkText={t('SOCIAL_STUDIES_TAKEDOWN_REQUEST_QUOTE_LINK_TEXT')}
                        />
                      ),
                    }}
                  />
                </Alert>
              </PageWrapper>
            )
          }
        }}
      />
    </ShareAssignmentErrorModalWrapper>
  )
}
